import { render } from "./PlansCard.vue?vue&type=template&id=972127fe&scoped=true"
import script from "./PlansCard.vue?vue&type=script&lang=js"
export * from "./PlansCard.vue?vue&type=script&lang=js"

import "./PlansCard.vue?vue&type=style&index=0&id=972127fe&scoped=true&lang=css"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972127fe"]])

export default __exports__